import facepaint from "facepaint";

const breakpoints: number[] = [280, 355];
export const mq = facepaint(breakpoints.map((bp) => `@media (max-width: ${bp}px)`));
